/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PaymentType,
  PaymentTypeOptional,
  PaymentTypeMetaI,
  PaymentTypeTrackedI,
} from "./payment-type";
import { PaymentTypeTracked, PaymentTypeMeta } from "./payment-type";

/**
 *
 * @export
 * @interface TransactionOtherBase
 */
export interface TransactionOtherBaseOptional {
  /**
   *
   * @type {PaymentType}
   * @memberof TransactionOtherBase
   */
  paymentType?: PaymentType;
  /**
   *
   * @type {string}
   * @memberof TransactionOtherBase
   */
  paymentTypeOther?: string;
  /**
   *
   * @type {string}
   * @memberof TransactionOtherBase
   */
  transactionInfo?: string;
  /**
   *
   * @type {string}
   * @memberof TransactionOtherBase
   */
  transactionExtra?: string;
  /**
   *
   * @type {number}
   * @memberof TransactionOtherBase
   */
  transactionAmount?: number;
}

export interface TransactionOtherBase extends TransactionOtherBaseOptional {
  /**
   *
   * @type {PaymentType}
   * @memberof TransactionOtherBase
   */
  paymentType?: PaymentType;
  /**
   *
   * @type {string}
   * @memberof TransactionOtherBase
   */
  paymentTypeOther?: string;
  /**
   *
   * @type {string}
   * @memberof TransactionOtherBase
   */
  transactionInfo?: string;
  /**
   *
   * @type {string}
   * @memberof TransactionOtherBase
   */
  transactionExtra?: string;
  /**
   *
   * @type {number}
   * @memberof TransactionOtherBase
   */
  transactionAmount?: number;
}

export interface TransactionOtherBaseTrackedI {
  /**
   *
   * @type {PaymentType}
   * @memberof TransactionOtherBase
   */
  paymentType?: PaymentType;
  paymentTypeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof TransactionOtherBase
   */
  paymentTypeOther?: string;
  paymentTypeOtherIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof TransactionOtherBase
   */
  transactionInfo?: string;
  transactionInfoIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof TransactionOtherBase
   */
  transactionExtra?: string;
  transactionExtraIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof TransactionOtherBase
   */
  transactionAmount?: number;
  transactionAmountIsSet: boolean;
}

transformDatesMap.set(
  "TransactionOtherBase",
  function (model: TransactionOtherBase) {},
);

export type TransactionOtherBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  paymentType: PropertyMeta<PaymentTypeMetaI>;
  //isDate: false
  //isDatetime: false
  paymentTypeOther: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  transactionInfo: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  transactionExtra: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  transactionAmount: PropertyMeta<MetaTypeBase<number>>;
}>;

export var TransactionOtherBaseMeta: TransactionOtherBaseMetaI =
  {} as TransactionOtherBaseMetaI;
TransactionOtherBaseMeta = typeMeta("TransactionOtherBase", {
  paymentType: propertyMeta(
    "paymentType",
    false,
    false,
    false,
    PaymentTypeMeta,
  ),
  paymentTypeOther: propertyMeta(
    "paymentTypeOther",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  transactionInfo: propertyMeta(
    "transactionInfo",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  transactionExtra: propertyMeta(
    "transactionExtra",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  transactionAmount: propertyMeta(
    "transactionAmount",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = TransactionOtherBaseMeta;

registerMeta(() => {});

export class TransactionOtherBaseTracked implements TransactionOtherBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  paymentType__I?: PaymentType = undefined;
  paymentTypeIsSet: boolean = false;
  set paymentType(v: undefined | PaymentType) {
    if (v !== undefined) {
      this.paymentType__I = v;
      this.paymentTypeIsSet = true;
    } else {
      this.paymentType__I = v || undefined;
      this.paymentTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentType() {
    return this.paymentType__I;
  }
  paymentTypeOther__I?: string = undefined;
  paymentTypeOtherIsSet: boolean = false;
  set paymentTypeOther(v: undefined | string) {
    if (v !== undefined) {
      this.paymentTypeOther__I = v;
      this.paymentTypeOtherIsSet = true;
    } else {
      this.paymentTypeOther__I = v || undefined;
      this.paymentTypeOtherIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentTypeOther() {
    return this.paymentTypeOther__I;
  }
  transactionInfo__I?: string = undefined;
  transactionInfoIsSet: boolean = false;
  set transactionInfo(v: undefined | string) {
    if (v !== undefined) {
      this.transactionInfo__I = v;
      this.transactionInfoIsSet = true;
    } else {
      this.transactionInfo__I = v || undefined;
      this.transactionInfoIsSet = false;
    }
    this.changeTracker = true;
  }
  get transactionInfo() {
    return this.transactionInfo__I;
  }
  transactionExtra__I?: string = undefined;
  transactionExtraIsSet: boolean = false;
  set transactionExtra(v: undefined | string) {
    if (v !== undefined) {
      this.transactionExtra__I = v;
      this.transactionExtraIsSet = true;
    } else {
      this.transactionExtra__I = v || undefined;
      this.transactionExtraIsSet = false;
    }
    this.changeTracker = true;
  }
  get transactionExtra() {
    return this.transactionExtra__I;
  }
  transactionAmount__I?: number = undefined;
  transactionAmountIsSet: boolean = false;
  set transactionAmount(v: undefined | number) {
    if (v !== undefined) {
      this.transactionAmount__I = v;
      this.transactionAmountIsSet = true;
    } else {
      this.transactionAmount__I = v || undefined;
      this.transactionAmountIsSet = false;
    }
    this.changeTracker = true;
  }
  get transactionAmount() {
    return this.transactionAmount__I;
  }
  constructor(config?: TransactionOtherBaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: TransactionOtherBaseOptional,
    options?: AssignOptions,
  ): TransactionOtherBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.paymentType &&
      this.paymentTypeApplyFilter(optionsRequired.filter)
    ) {
      this.paymentType = config.paymentType;
      if (optionsRequired.unassign) this.paymentTypeIsSet = false;
      else this.paymentTypeIsSet = true;
    }
    if (
      config.paymentTypeOther &&
      this.paymentTypeOtherApplyFilter(optionsRequired.filter)
    ) {
      this.paymentTypeOther = config.paymentTypeOther;
      if (optionsRequired.unassign) this.paymentTypeOtherIsSet = false;
      else this.paymentTypeOtherIsSet = true;
    }
    if (
      config.transactionInfo &&
      this.transactionInfoApplyFilter(optionsRequired.filter)
    ) {
      this.transactionInfo = config.transactionInfo;
      if (optionsRequired.unassign) this.transactionInfoIsSet = false;
      else this.transactionInfoIsSet = true;
    }
    if (
      config.transactionExtra &&
      this.transactionExtraApplyFilter(optionsRequired.filter)
    ) {
      this.transactionExtra = config.transactionExtra;
      if (optionsRequired.unassign) this.transactionExtraIsSet = false;
      else this.transactionExtraIsSet = true;
    }
    if (
      config.transactionAmount &&
      this.transactionAmountApplyFilter(optionsRequired.filter)
    ) {
      this.transactionAmount = config.transactionAmount;
      if (optionsRequired.unassign) this.transactionAmountIsSet = false;
      else this.transactionAmountIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): TransactionOtherBaseTrackedI {
    const cloned = {} as TransactionOtherBaseTrackedI;
    if (
      this.paymentTypeIsSetDeep() &&
      this.paymentTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentTypeIsSet = true;
      cloned.paymentType = this.paymentType;
    } else {
      //cloned.paymentTypeIsSet = false
    }
    if (
      this.paymentTypeOtherIsSetDeep() &&
      this.paymentTypeOtherApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentTypeOtherIsSet = true;
      cloned.paymentTypeOther = this.paymentTypeOther;
    } else {
      //cloned.paymentTypeOtherIsSet = false
    }
    if (
      this.transactionInfoIsSetDeep() &&
      this.transactionInfoApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.transactionInfoIsSet = true;
      cloned.transactionInfo = this.transactionInfo;
    } else {
      //cloned.transactionInfoIsSet = false
    }
    if (
      this.transactionExtraIsSetDeep() &&
      this.transactionExtraApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.transactionExtraIsSet = true;
      cloned.transactionExtra = this.transactionExtra;
    } else {
      //cloned.transactionExtraIsSet = false
    }
    if (
      this.transactionAmountIsSetDeep() &&
      this.transactionAmountApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.transactionAmountIsSet = true;
      cloned.transactionAmount = this.transactionAmount;
    } else {
      //cloned.transactionAmountIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): TransactionOtherBaseTrackedI {
    if (!this.paymentTypeApplyFilter(filter)) this.paymentTypeIsSet = false;

    if (!this.paymentTypeOtherApplyFilter(filter))
      this.paymentTypeOtherIsSet = false;

    if (!this.transactionInfoApplyFilter(filter))
      this.transactionInfoIsSet = false;

    if (!this.transactionExtraApplyFilter(filter))
      this.transactionExtraIsSet = false;

    if (!this.transactionAmountApplyFilter(filter))
      this.transactionAmountIsSet = false;

    return this;
  }
  paymentTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      TransactionOtherBaseMeta.paymentType,
      TransactionOtherBaseMeta,
      this.paymentType,
      this,
    );
  }
  paymentTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentTypeIsSet && this.paymentTypeApplyFilter(filter))
      return true;

    return false;
  }
  paymentTypeOtherApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      TransactionOtherBaseMeta.paymentTypeOther,
      TransactionOtherBaseMeta,
      this.paymentTypeOther,
      this,
    );
  }
  paymentTypeOtherIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentTypeOtherIsSet && this.paymentTypeOtherApplyFilter(filter))
      return true;

    return false;
  }
  transactionInfoApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      TransactionOtherBaseMeta.transactionInfo,
      TransactionOtherBaseMeta,
      this.transactionInfo,
      this,
    );
  }
  transactionInfoIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.transactionInfoIsSet && this.transactionInfoApplyFilter(filter))
      return true;

    return false;
  }
  transactionExtraApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      TransactionOtherBaseMeta.transactionExtra,
      TransactionOtherBaseMeta,
      this.transactionExtra,
      this,
    );
  }
  transactionExtraIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.transactionExtraIsSet && this.transactionExtraApplyFilter(filter))
      return true;

    return false;
  }
  transactionAmountApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      TransactionOtherBaseMeta.transactionAmount,
      TransactionOtherBaseMeta,
      this.transactionAmount,
      this,
    );
  }
  transactionAmountIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.transactionAmountIsSet &&
      this.transactionAmountApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.paymentTypeIsSetDeep(filter)) return true;
    if (this.paymentTypeOtherIsSetDeep(filter)) return true;
    if (this.transactionInfoIsSetDeep(filter)) return true;
    if (this.transactionExtraIsSetDeep(filter)) return true;
    if (this.transactionAmountIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
